import { AssistantPendingAction } from '@api/shovelAiApi';
import Button from '@components/common/buttons/Button';
import { Column, Row } from '@components/common/layoutUtils';
import colors from '@utils/colors';
import { MiniText, RegularText } from '@utils/typography';
import Loader from 'react-loader-spinner';
import styled from 'styled-components';

type Props = {
  action: AssistantPendingAction;
  confirming: boolean;
  successMessage?: string;
  onConfirm: () => void;
  onDismiss: () => void;
};

const PendingActionCard = ({ action, confirming, successMessage, onConfirm, onDismiss }: Props) => {
  if (successMessage) {
    return (
      <Card>
        <SuccessText>{successMessage}</SuccessText>
      </Card>
    );
  }

  return (
    <Card>
      <RegularText>{action.summary}</RegularText>
      <Actions>
        <Button size="sm" filled onClick={onConfirm} disabled={confirming}>
          {confirming ? (
            <Row style={{ gap: 6, alignItems: 'center' }}>
              <Loader type="Oval" color={colors.white} height={14} width={14} />
              <MiniText color={colors.white}>Confirming...</MiniText>
            </Row>
          ) : (
            'Approve'
          )}
        </Button>
        <Button size="sm" onClick={onDismiss} disabled={confirming}>
          Cancel
        </Button>
      </Actions>
    </Card>
  );
};

export default PendingActionCard;

const Card = styled(Column)`
  gap: 10px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.backgroundLight};
`;

const Actions = styled(Row)`
  gap: 8px;
`;

const SuccessText = styled(RegularText)`
  color: ${colors.positive};
`;
